import Image from 'components/Image';
import { getCorrectFileUrl } from '@helpers/urlsHelper';

import s from './ChatImage.module.scss';

type Props = {
  url: string;
  alt?: string;
};

const ChatImage: React.FC<Props> = ({ url, alt = 'image' }) => {
  const imageUrl = getCorrectFileUrl(url);

  return (
    <Image
      className={s['chat-image']}
      image={imageUrl}
      alt={alt} />
  );
};

export default ChatImage;
